<template>
  <section>
    <div class="lm-header">
      <h2
        class="title is-5"
        v-text="$t('DashboardAdmin.title').toUpperCase()"
      />
    </div>
    <admin />
  </section>
</template>

<script>
import Admin from '@/components/dashboard/Admin'

export default {
  name: 'DashboardAdmin',
  beforeCreate () {
    this.$store.dispatch('orders/flush')
    this.$store.dispatch('filters/flush')
  },
  beforeDestroy () {
    this.$eventBus.$off('registration')
  },
  components: {
    Admin
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardAdmin.vue